module.exports = "<div class=\"container my-container\">\n        <div class=\"page-content\" [innerHTML]=\"content[activeLanguage]\"></div>\n    </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-semiconductors/services-semiconductors.component.html
// module id = ./src/app/components/services-semiconductors/services-semiconductors.component.html
// module chunks = main